import { namespacedConsts } from '../../utils/object'
import { appDispatcher } from '../../application/AppDispatcher'

const CONSTS = namespacedConsts({
  MODAL: {
    ACTIONS: {
      CLOSE: true,
    },
  },
})

export const TYPES = CONSTS.MODAL.ACTIONS

export const closeModal = () => {
  appDispatcher.dispatchAction.view({
    type: TYPES.CLOSE,
  })
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/actions/modalActions.js